/*
 * Listing Messages
 *
 * This contains all the text for the Listing component.
 */

import { defineMessages } from 'react-intl';
import defaults from '../../../translations/en.json';

export const messages = defineMessages({
  certTab: {
    id: 'header.cerTab',
    defaultMessage: 'Certifications',
  },
  approvalTab: {
    id: 'header.approvalTab',
    defaultMessage: 'Unsigned Verbals',
  },
  reviewTab: {
    id: 'header.reviewTab',
    defaultMessage: 'Reviews',
  },
  daysOverdue: {
    id: 'grid.daysOverdue',
    defaultMessage: 'Overdue {days} days',
  },
  cert: {
    id: 'Certifying',
    defaultMessage: 'Certifying',
  },
  attd: {
    id: 'Attending',
    defaultMessage: 'Attending',
  },
  verb: {
    id: 'Verbal',
    defaultMessage: 'Verbal',
  },
  noVerbal: {
    id: 'noVerbal',
    defaultMessage: 'No Verbal',
  },
  dueToday: {
    id: 'dueToday',
    defaultMessage: 'Due Today',
  },
  sigRequired: {
    id: 'sigRequired',
    defaultMessage: 'Signature Required',
  },
  needed: {
    id: 'Needed',
    defaultMessage: 'Needed',
  },
  done: {
    id: 'Done',
    defaultMessage: 'Done',
  },
  resetAll: {
    id: 'grid.resetAll',
    defaultMessage: defaults['grid.resetAll'],
  },
  filterProv: {
    id: 'filterProv',
    defaultMessage: 'Filter by prov.',
  },
  filterDate: {
    id: 'filterDate',
    defaultMessage: 'Filter by date',
  },
  doneOn: {
    id: 'grid.doneOn',
    defaultMessage: 'Done {date}',
  },
  notRequired: {
    id: 'Not Required',
    defaultMessage: 'Not Required',
  },
  rowsLoaded: {
    id: 'grid.rowsLoaded',
    defaultMessage: '{rows} rows loaded',
  },
  chart: {
    id: 'chart',
    defaultMessage: 'Chart',
  },
  notSetup: {
    id: 'phead.notSetup',
    defaultMessage: 'This user is not configured for ClearScripts',
  },
  bulkPrintByPhysicianTitle: {
    id: 'approval.bulkPrintByPhysicianTitle',
    defaultMessage: 'Print by ordering provider',
  },
  bulkPrintSelectPhysician: {
    id: 'approval.bulkPrintSelectPhysician',
    defaultMessage: 'Select a provider, then open print.',
  },
  bulkPrintOpenPrint: {
    id: 'approval.bulkPrintOpenPrint',
    defaultMessage: 'Open print',
  },
  bulkPrintDialogTitle: {
    id: 'approval.bulkPrintDialogTitle',
    defaultMessage: 'Unsigned Verbals \u2014 {doctorName}',
  },
  bulkPrintPreparing: {
    id: 'approval.bulkPrintPreparing',
    defaultMessage: 'Gathering verbal orders\u2026',
  },
  bulkPrintSearchPhysician: {
    id: 'approval.bulkPrintSearchPhysician',
    defaultMessage: 'Search providers',
  },
  bulkPrintReadyHint: {
    id: 'approval.bulkPrintReadyHint',
    defaultMessage: 'Use the icon in the header to print or fax.',
  },
  bulkPrintSummaryPatient: {
    id: 'approval.bulkPrintSummaryPatient',
    defaultMessage: 'Patient',
  },
  bulkPrintSummaryOrderType: {
    id: 'approval.bulkPrintSummaryOrderType',
    defaultMessage: 'Type',
  },
  bulkPrintSummaryDate: {
    id: 'approval.bulkPrintSummaryDate',
    defaultMessage: 'Recorded',
  },
  bulkPrintSummaryRequestedBy: {
    id: 'approval.bulkPrintSummaryRequestedBy',
    defaultMessage: 'Requestor',
  },
  bulkPrintSummaryEmpty: {
    id: 'approval.bulkPrintSummaryEmpty',
    defaultMessage: 'No verbal orders loaded for this summary.',
  },
  unsignedVerbalsPrintFailed: {
    id: 'approval.unsignedVerbalsPrintFailed',
    defaultMessage: 'Could not print unsigned verbals. {message}',
  },
  unsignedVerbalsPrintNothingToPrint: {
    id: 'approval.unsignedVerbalsPrintNothingToPrint',
    defaultMessage:
      'There is nothing to print yet. Try again in a moment, or reopen this window if the problem continues.',
  },
  unsignedVerbalsPrintUserRequired: {
    id: 'approval.unsignedVerbalsPrintUserRequired',
    defaultMessage:
      'Your user profile is still loading or unavailable. Wait a moment and try again, or refresh the page.',
  },
  physicianNameCol: {
    id: 'approval.physicianNameCol',
    defaultMessage: 'Ordering provider',
  },
});

export default messages;
